module.exports = __webpack_public_path__ + "img/icon-kefu@2x.8248c2ab.png";